import React from "react";
import SnackbarContent from "../components/Snackbar/SnackbarContent.jsx";
import {alertConstants} from "../_constants";

export const AlertBar = ({message, alertType = alertConstants.ERROR}) =>
    {
        let alertColor = "danger";
        if(alertType === alertConstants.SUCCESS)
            alertColor = "success";

       return  (<SnackbarContent
            message={
                message
            }
            classes={{message: 'text-center'}}
            color={alertColor}
        />)
    };




// WEBPACK FOOTER //
// ./src/utils/AlertBar.jsx